import React, { Component } from "react";
import { persistStore } from "redux-persist";
import Spinner from "react-webpack-spinner";

import { getStore, history } from "../store";
import Root from "./Root";
import ModalLoading from "./ModalLoading";

export default class AppProvider extends Component {
  state = { rehydrated: false };

  componentWillMount() {
    persistStore(getStore(), { autoRehydrate: true }, () => {
      this.setState({ rehydrated: true });
    });
  }

  render() {
    if (!this.state.rehydrated) {
      return <ModalLoading isActive={true} />;
    }
    return <Root store={getStore()} history={history} />;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/RehydrateProvider.jsx
 **/